// 테스트 관련 코드, 추후 삭제 예정
/**
 * 테스트 페이지(약관확인·가이드확인) 전용 REST 호출.
 * BE(sv-indipia) 기존 엔드포인트를 그대로 사용한다 — 신규 추가 없음.
 *   - GET /indipia/codes?codeGroupCode=ZEU_TERM_TYPE   약관 유형 코드
 *   - GET /indipia/terms?type=                          유형별 약관(현재 ACTIVE_YN=Y 1건)
 *   - GET /indipia/agents                               활성 에이전트 목록
 *   - GET /indipia/agents/guide/{agentId}               에이전트 가이드
 */
import { apiClient, API_PRX } from '@indipia/shared';

const IDP = API_PRX.INDIPIA;

export interface TermsTypeCode {
  codeGroupCode: string;
  codeValue: string;
  codeName: string;
  codeOrder: number;
}
export interface TermsContent {
  type: string;
  termsTitle: string;
  termsContent: string;     // HTML
  updatedAt: string;
}
export interface AgentItem {
  agentId: number;
  agentName: string;
  requiredSteps: string | null;
}
export interface AgentGuide {
  agentId: number;
  agentGuide: string | null;
}

/** ApiResponse<T> → data 언래핑 */
function unwrap<T>(res: { data?: { data?: T } }): T | undefined {
  return res?.data?.data;
}

export async function fetchTermsTypes(): Promise<TermsTypeCode[]> {
  const res = await apiClient.get(`${IDP}/codes`, { params: { codeGroupCode: 'ZEU_TERM_TYPE' } });
  return unwrap<TermsTypeCode[]>(res) ?? [];
}

export async function fetchTerms(type: string): Promise<TermsContent | undefined> {
  const res = await apiClient.get(`${IDP}/terms`, { params: { type } });
  return unwrap<TermsContent>(res);
}

export async function fetchAgents(): Promise<AgentItem[]> {
  const res = await apiClient.get(`${IDP}/agents`);
  return unwrap<AgentItem[]>(res) ?? [];
}

export async function fetchAgentGuide(agentId: number): Promise<AgentGuide | undefined> {
  const res = await apiClient.get(`${IDP}/agents/guide/${agentId}`);
  return unwrap<AgentGuide>(res);
}
